import React from 'react';

import { Icon } from '~/packages/common-frontend/components/icons';
import { GlobalNavRouterLinkItem } from '~/packages/common-frontend/layout';

export const UploadNavItem = (): React.ReactElement => {
  return (
    <GlobalNavRouterLinkItem
      to="/upload"
      label="Upload"
      icon={<Icon icon="arrow-up-from-bracket" />}
    />
  );
};
